import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './styles/sidebar.css';

const Sidebar = ({ links = [], onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  let displayName = '';
  try {
    const token = localStorage.getItem('authToken');
    if (token) {
      const decoded = jwtDecode(token);
      // En el token el nombre viene como "unique_name"
      displayName = decoded?.unique_name || '';
    }
  } catch (e) {
    // Ignorar errores de decodificación
  }

  return (
    <aside className={`sidebar${isOpen ? ' open' : ''}`}>
      <button
        type="button"
        className="sidebar-title sidebar-toggle"
        aria-expanded={isOpen}
        aria-controls="sidebar-collapsible"
        onClick={() => setIsOpen(prev => !prev)}
      >
        TIKETERIA
      </button>
      {displayName && (
        <div className="sidebar-username" style={{ marginTop: '4px', marginBottom: '24px', color: '#e5e7eb', fontSize: '16px', textAlign: 'center' }}>
          {displayName}
        </div>
      )}
      <nav id="sidebar-collapsible" className="sidebar-nav">
        {links.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`sidebar-link${location.pathname === link.to ? ' active' : ''}`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
      <button
        className="sidebar-logout"
        onClick={() => {
          localStorage.removeItem('authToken');
          if (onLogout) onLogout();
          navigate('/auth/login');
        }}
      >
        Cerrar sesión
      </button>
    </aside>
  );
};

export default Sidebar;